export { SuiPaginationModule } from "./index";
//# sourceMappingURL=public.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/collections/pagination/public.js
// module id = 1084
// module chunks = 0